import AnimationIcon from "../common/icons/more/AnimationIcon";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import appPages from "../../../appPages";
import IntegrationIcons from "../common/icons/integrations";
import { INTEGRATION_KEYS } from "../integrations/IntegrationsHelper";
import ManaIcon from "../common/icons/ManaIcon";

export default [
  {
    id: 1,
    name: "Show mid-week card",
    value: "mid_week_card",
    icon: null,
    hasToggle: true,
  },
  {
    id: 3,
    name: "Show goal card",
    value: "goal_card",
    icon: null,
    hasToggle: true,
  },
  {
    id: 4,
    name: "Show reflection card",
    value: "reflection_card",
    icon: null,
    hasToggle: true,
  },
  {
    id: 6,
    name: "Show Tutorials Card",
    value: "show_tutorials_card",
    icon: null,
    hasToggle: true,
  },
  {
    id: 7,
    name: "Show Calendar integration card",
    value: `show_${INTEGRATION_KEYS.calendar}_integration_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 8,
    name: "Show Apple Health integration card",
    value: `show_${INTEGRATION_KEYS.health}_integration_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 9,
    name: "Show Desktop Sync integration card",
    value: `show_${INTEGRATION_KEYS.desktop}_integration_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 10,
    name: "Show Integrations Mapping Card",
    value: `show_mapping_integration_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 11,
    name: "Show Integrations Reconnect Cards",
    value: `show_integrations_reconnect_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 12,
    name: "Show Onboarding Progress Card",
    value: `show_integrations_progress_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 13,
    name: "Show Stats Card",
    value: `show_stats_card`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 14,
    name: "Show Icons in Track Page",
    value: `show_icons_in_track_page`,
    icon: null,
    hasToggle: true,
  },
  {
    id: 101,
    name: "Animation",
    iconTag: AnimationIcon,
    page: appPages.onboardingAnimPage,
  },
  {
    id: 201,
    name: "Integrations",
    iconTag: IntegrationIcons.IntegrationsIconGradient,
    page: appPages.integrationsV2,
  },
  {
    id: 202,
    name: "Integrations Onboarding",
    iconTag: IntegrationIcons.IntegrationsIconGradient,
    page: appPages.integrationsOnboarding,
  },
  {
    id: 203,
    name: "Customize Elements",
    iconTag: ManaIcon,
    page: appPages.customizeElementsPage,
  },
  ...TutorialsHelper.tutorials,
];
